import React from "react";
import {
  RedButton,
  CustomLabel,
  FlexContainer,
  Input,
  ModalComponent,
  withRouter,
  ToastService, 
} from "@mindmemobile/mm-shared-global";
import { observer } from "mobx-react";
import { NavigateFunction } from "react-router-dom"; 
import { SellerGridModel } from "../../../shared/models";
import { AuthService, SellerService } from "../../../shared/services";

type IProps = {
  navigate: NavigateFunction;
  sellerData: SellerGridModel;
  onClose: (refresh: boolean) => void;
};

const DeleteSellerPopup: React.FC<IProps> = ({ onClose, sellerData }) => {
  const [isAPIRequestPending, setAPIRequestPending] = React.useState(false);
  const [isConfirmed, setConfirmation] = React.useState(false);

  function onDelete() {
      if (isAPIRequestPending) return;

      setAPIRequestPending(true);
      SellerService.deleteSeller(AuthService.authData.accountId, sellerData.id).subscribe({
          next: (response) => {
              setAPIRequestPending(false);
              if (response.result.success) {
                  ToastService.showSuccess('Seller Deleted Successfully');
              }
              onClose(true);
          },
          error: () => {
              setAPIRequestPending(false);
              ToastService.showError('Error in deleting seller');
          },
      });
  }

  function renderAddress(address: string, addBreak: boolean, addComma: boolean = false, addSpace: boolean = false) {
      if (!address) return null;
      return (
          <>
              {addSpace && ' '} {address}
              {addBreak && <br />}
              {addComma && ', '}
          </>
      );
  }

  const renderContent = () => {
      const address = sellerData.address;
      return (
          <FlexContainer fxLayout="column" spacing={30} alignItems="center">
              <CustomLabel>
                  Do you want to <span className="red-text semi-bold">delete</span> this Seller?
              </CustomLabel>
              <CustomLabel textAlign="center">
                  {sellerData.name}
                  <br />
                  {renderAddress(address?.address1, true)}
                  {renderAddress(address?.address2, true)}
                  {renderAddress(address?.city, false, true)}
                  {renderAddress(address?.state?.name, false)}
                  {renderAddress(address?.zipCode, true)}
                  {renderAddress(address?.countryDetails?.name, true)}
              </CustomLabel>
              <Input
                  type="checkbox"
                  label="Confirm Deletion"
                  value={isConfirmed}
                  onChange={(e) => setConfirmation(e.target.checked)}
              />

              <CustomLabel fontSize={'14px'} lineHeight="18px" textAlign="center">
                  If there are existing transactions associated with this Seller, it will not be permanently deleted,
                  but it will be unavailable for future sales.
              </CustomLabel>
          </FlexContainer>
      );
  };

  return (
      <ModalComponent
          title={'Delete Seller'}
          titleFontSize="22px"
          bodyPadding="30px 55px 20px 54px"
          onClose={() => onClose && onClose(false)}
          showFooter={true}
          wrapperWidth="600px"
          bodyBackgroundColor="rgba(255, 255, 255, 1)"
          footerBackground="rgba(255, 0, 0, 0.1)"
          footerHeight="auto"
          minHeight="200px"
          redHeader={true}
          blueHeader={false}
          footerContent={
              <FlexContainer alignItems="center" justifyContent="center" spacing={15}>
                  <RedButton lineHeight="13px" minWidth="120px" height="30px" onClick={() => onClose(false)}>
                      Do not Delete
                  </RedButton>
                  <RedButton
                      lineHeight="13px"
                      primary
                      disabled={isAPIRequestPending || !isConfirmed}
                      minWidth="120px"
                      height="30px"
                      onClick={() => onDelete()}
                  >
                      Delete
                  </RedButton>
              </FlexContainer>
          }
      >
          {renderContent()}
      </ModalComponent>
  );
};

export default withRouter(observer(DeleteSellerPopup));
